<template>
    <div class="context">
        <keep-alive include="tableView">
            <component
                :is="componentId"
                @changeTopTab="switchModule"
                :ref="componentId">
            </component>
        </keep-alive>
    </div>
</template>

<script>
    import tableView from "./tableView"
    import addView from "./add"

    export default {
        name: "",
        components: {
            tableView,
            addView,
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id;
                if(id === 'tableView'){
                    this.$eventBus.$emit("pollPort")
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
</style>